module.exports = __webpack_public_path__ + "static/media/logo_alt.46129f4b.png";